"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMarkupRender = void 0;
const react_1 = __importStar(require("react"));
const tcb_component_markup_parser_1 = require("@tencent/tcb-component-markup-parser");
const DefaultComponent = ({ content }) => react_1.default.createElement("span", null, content);
function useMarkupRender(options = {}) {
    const render = (0, react_1.useCallback)((content) => {
        let result = [content];
        try {
            const parsedContents = (0, tcb_component_markup_parser_1.parse)(content);
            result = parsedContents.map(markup => {
                var _a, _b, _c, _d, _e;
                switch (markup.type) {
                    case tcb_component_markup_parser_1.TextType.DANGER: {
                        const Danger = (_a = options[tcb_component_markup_parser_1.TextType.DANGER]) !== null && _a !== void 0 ? _a : DefaultComponent;
                        return react_1.default.createElement(Danger, { key: markup.content.toString(), content: markup.content.toString() });
                    }
                    case tcb_component_markup_parser_1.TextType.WARNING: {
                        const Warning = (_b = options[tcb_component_markup_parser_1.TextType.WARNING]) !== null && _b !== void 0 ? _b : DefaultComponent;
                        return (react_1.default.createElement(Warning, { key: markup.content.toString(), content: markup.content.toString() }));
                    }
                    case tcb_component_markup_parser_1.TextType.INFO: {
                        const Info = (_c = options[tcb_component_markup_parser_1.TextType.INFO]) !== null && _c !== void 0 ? _c : DefaultComponent;
                        return (react_1.default.createElement(Info, { key: markup.content.toString(), content: markup.content.toString(), extra: markup.addon }));
                    }
                    case tcb_component_markup_parser_1.TextType.LINK: {
                        const Link = (_d = options[tcb_component_markup_parser_1.TextType.LINK]) !== null && _d !== void 0 ? _d : DefaultComponent;
                        return (react_1.default.createElement(Link, { key: markup.content.toString(), content: markup.content.toString(), href: markup.addon }));
                    }
                    default: {
                        const Plain = (_e = options[tcb_component_markup_parser_1.TextType.PLAIN]) !== null && _e !== void 0 ? _e : DefaultComponent;
                        return react_1.default.createElement(Plain, { key: markup.content.toString(), content: markup.content.toString() });
                    }
                }
            });
        }
        catch (err) {
            console.error(err);
        }
        return result;
    }, [options]);
    return render;
}
exports.useMarkupRender = useMarkupRender;
